import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../../services/sysadmin.service";
import { UserModifyAddUserGroupsComponent } from "./user-modify-add-user-groups/user-modify-add-user-groups.component";

@Component({
	selector: "caass-user-modify-user-groups",
	templateUrl: "./user-modify-user-groups.component.html",
	styleUrls: ["./user-modify-user-groups.component.css"],
})
export class UserModifyUserGroupsComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService) {}

	ngOnInit(): void {
		if (this.EditMode == true && this.InitLoad == false) {
			this.InitLoad = true;

			this.loadUserGroups();
		}
	}

	ngOnChanges() {
		if (this.EditMode == true && this.InitLoad == false) {
			this.InitLoad = true;

			this.loadUserGroups();
		}
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	InitLoad: any = false;

	@Input() EditMode: any = false;
	@Input() UserID: any = -1;

	@Input() UserLevelID: any; //Edit Only
	@Input() Processing: any;

	//Table Data
	loading: any = false;
	SelectedGroups: any = [];
	lstUserGroup: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "UserGroupDesc", header: "User Group" },
		{ field: "SchoolCount", header: "# of Schools" },
		{ field: "PageCount", header: "# of Pages" },
	];

	errorMessage: any = "";

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////

	loadUserGroups() {
		if (this.UserID == undefined || this.UserID <= 0) {
			return;
		}

		this.loading = true;

		var result = this.sysAdminService.SysAdminUserUserGroupsSelect(this.UserID);
		result.subscribe(
			(response) => {
				this.lstUserGroup = response;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onAdd() {
		var ref = this.dialogService.open(UserModifyAddUserGroupsComponent, {
			header: "Add User Group",
			width: "fit-content",
			data: {
				UserLevelID: this.UserLevelID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.lstUserGroup = response;
			}
		});
	}

	onRemove() {
		this.lstUserGroup = this.lstUserGroup.filter((group) => this.SelectedGroups.indexOf(group) == -1);

		this.SelectedGroups = [];
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
